import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

export const TextInput = ({
  label,
  placeholder,
  type,
  error,
  error_msg,
  show,
  onShow,
  pattern,
  disabled = false,
  ...props
}) => {
  return (
    <div>
      <label style={{ fontSize: 14, fontWeight: 600 }}>{label}</label>
      {props.name === 'password' ? (
        <div className="input-group" >
          <input

            type={show ? 'text' : 'password'}
            style={{ borderRadius: 4, borderColor: error && error_msg ? 'red' : '#ced4da' }}
            className="form-control"
            placeholder={placeholder}
            autoComplete='new-password'
            {...props}
          />
          <div className="input-group-prepend">
            <span
              className="input-group-text"
              onClick={() => {
                onShow('password', show);
              }}
              id="inputGroupPrepend2"
            >
              <FontAwesomeIcon icon={show ? faEyeSlash : faEye} />
            </span>
          </div>
        </div>
      ) : props.name === 'password_confirm' ? (
        <div className="input-group" data-error={error}
          data-msg={error_msg}>
          <input
            type={show ? 'text' : 'password'}
            style={{ borderRadius: 4, borderColor: error && error_msg ? 'red' : '#ced4da' }}
            className="form-control"
            placeholder={placeholder}
            autoComplete='new-password'
            {...props}
          />
          <div className="input-group-prepend">
            <span
              className="input-group-text"
              onClick={() => {
                onShow('password_confirm', show);
              }}
              id="inputGroupPrepend2"
            >
              <FontAwesomeIcon icon={show ? faEyeSlash : faEye} />
            </span>
          </div>
        </div>
      ) : (
        <input
          className="form-control shadow-none outline-none"
          style={{ borderRadius: 4, borderColor: error && error_msg ? 'red' : '#ced4da' }}
          type={type}
          placeholder={placeholder}
          disabled={disabled}
          min={0}
          {...props}
        />
      )}
      {error && error_msg && <label style={{ fontSize: 13, color: 'red', fontWeight: 600 }}>{error_msg}</label>}
    </div>
  );
};
